const fjsti_url = 'https://tsnqb.fjsti.uz/api/';
// const fjsti_url = 'http://localhost:3100/';
//fjsti prod///////////
export const environment_fjsti = {
  otm: 'fjsti',
  production: true,
  http_auth: 'NSJNAB&237BNSFISNM',
  otm_name:
    "Farg'ona jamoat salomatligi tibbiyot instituti professor-o‘qituvchilari milliy reytingini baholash platformasi",
  firebaseConfig: {
    // pvorey
    apiKey: 'AIzaSyCdXdbQrCOcdXI183VIcmetut_dCKG5dOU',
    authDomain: 'fjsti-c50ff.firebaseapp.com',
    projectId: 'fjsti-c50ff',
    storageBucket: 'fjsti-c50ff.appspot.com',
    messagingSenderId: '382705767044',
    appId: '1:382705767044:web:48527a1aeb7e8674c4e8d1',
    measurementId: 'G-L4NGYJKBMN',
  },
  http: {
    socket: {
      path: 'ws://ferpi.tsnqb.uz/socket.io',
    },
    editArea: {
      path: fjsti_url + 'system/area',
    },
    addArea: {
      path: fjsti_url + 'system/area',
    },
    deleteArea: {
      path: fjsti_url + 'system/area',
    },
    usersPaginated: {
      path: fjsti_url + '' + 'users/paginated',
    },
    updateUser: {
      path: fjsti_url + '' + 'users/',
    },
    removeDepartment: {
      path: fjsti_url + 'system/department',
    },
    editDepartment: {
      path: fjsti_url + 'system/department',
    },
    getDepartmentAArea: {
      path: fjsti_url + 'system/getAll',
    },
    getIndexDataByTeacher: {
      path: fjsti_url + 'index/by-teacher',
    },
    addDepartment: {
      path: fjsti_url + 'system/department',
    },
    userRegister: {
      path: fjsti_url + 'auth/registration',
    },
    recoverPass: {
      path: fjsti_url + 'mailing/send-mail',
    },
    allRoles: {
      path: fjsti_url + 'auth/login',
    },
    removeRole: {
      path: fjsti_url + 'auth/login',
    },
    setRole: {
      path: fjsti_url + 'auth/login',
    },
    removeTeacher: {
      path: fjsti_url + 'auth/login',
    },
    allUsers: {
      path: fjsti_url + 'users/all',
    },
    // updateUser: {
    //   path: fjsti_url+ 'auth/login',
    // },
    deleteUser: {
      path: fjsti_url + 'auth/login',
    },
    login: {
      path: fjsti_url + 'auth/login',
    },
    autologin: {
      path: fjsti_url + 'auth/autologin',
    },
    updateIndex: {
      path: fjsti_url + 'index/update',
    },
    updateIndexOnlyShare: {
      path: fjsti_url + 'index/update_only_share',
    },
    rateIndex: {
      path: fjsti_url + 'index/rate',
    },
    get: {
      path: 'https://tsnqb.fjsti.uz/db/2026/get_data.php',
      file: 'pvorey.txt',
    },
    delete_only_inform_file: {
      path: 'https://tsnqb.fjsti.uz/db/2026/delete_only_inform_file.php',
    },
    getFieldsInform: {
      path: 'https://tsnqb.fjsti.uz/db/2026/get_fields_inform.php',
    },
    setInc: {
      path: 'https://tsnqb.fjsti.uz/db/2026/set_data_inc.php',
      file: 'pvorey.txt',
    },
    del: {
      path: 'https://tsnqb.fjsti.uz/db/2026/del_data.php',
      file: 'pvorey.txt',
    },
    setIncDelUpd: {
      path: 'https://tsnqb.fjsti.uz/db/2026/set_inc_del_upd.php',
      file: 'pvorey.txt',
    },
    remDocDownGrade: {
      path: 'https://tsnqb.fjsti.uz/db/2026/rem_doc_with_down_grade.php',
    },
    googleScholarCited: {
      path: 'https://tsnqb.fjsti.uz/db/2026/google_scholar.php',
    },
    googleScholarCitedAll: {
      path: 'https://tsnqb.fjsti.uz/db/2026/google_scholar_all.php',
    },
    setNewPvo: {
      path: 'https://tsnqb.fjsti.uz/db/2026/set_new_pvo.php',
    },
    removePvo: {
      path: 'https://tsnqb.fjsti.uz/db/2026/remove_pvo.php',
    },
    controlIndexStatus: {
      path: 'https://tsnqb.fjsti.uz/db/2026/control_index_status.php',
    },
    createAnnounce: {
      path: 'https://tsnqb.fjsti.uz/db/2026/create_announce.php',
    },
    getAnnounces: {
      path: 'https://tsnqb.fjsti.uz/db/2026/get_announces.php',
    },
    removeAnnounce: {
      path: 'https://tsnqb.fjsti.uz/db/2026/remove_announce.php',
    },
    editUserAccaunt: {
      path: 'https://tsnqb.fjsti.uz/db/2026/edit_user_account.php',
    },
    createIndex: {
      path: 'https://tsnqb.fjsti.uz/db/2026/create_index.php',
    },
  },
  tizim: [
    {
      fakultet: 'Tibbiy profilaktika va jamoat salomatligi',
      kafedralar: [
        'Kommunal va mehnat gigiyenasi',
        'Ovqatlanish, bolalar va o’smirlar gigienasi',
        'Preventiv tibbiyot asoslari, jamoat salomatligi, jismoniy tarbiya va sport',
        'Epidemiologiya va yuqumli kasalliklar, hamshiralik ishi',
        'Mikrobiologiya, virusologiya va immunologiya        ',
        'Xalq tabobati va farmakologiya',
        'Biotibbiyot muhandisligi, biofizika va axborot texnologiyalari',
      ],
    },
    {
      fakultet: 'Davolash',
      kafedralar: [
        'Ichki kasallalliklar propedevtikasi (UASH)',
        'Terapiya yo‘nalishidagi fanlar (UASH)',
        'Travmatologiya va ortopediya',
        'Normal anatomiya, operativ jarrohlik va topografik anatomiya',
        'Gospital terapiya (laboratoriya)',
        'Umumiy jarrohlik',
        'Fakultet va gospital jarrohlik',
        'Akusherlik va ginekologiya',
      ],
    },
    {
      fakultet: 'Pediatriya',
      kafedralar: [
        'Urologiya va onkologiya',
        'Nevrologiya va psixiatriya',
        'Pediatriya',
        'Pediatriya 2',
        'Stomatologiya va otoloringologiya',
        'Dermatovenerologiya va allergologiya',
        'Endokrinologiya, gemotologiya va ftiziatriya',
      ],
    },
    {
      fakultet: 'Xalqaro',
      kafedralar: [
        "O'zbek va xorijiy tillar",
        'Lotin tili, pedagogika va psixologiya',
        'Tibbiy va biologik kimyo',
        'Ijtimoiy fanlar',
        'Gistologiya va biologiya',
        'Fiziologiya',
        'Patologik fiziologiya va patologik anatomiya',
      ],
    },
  ],
  grastud: 600,
  fakultet: [
    'Tibbiy profilaktika va jamoat salomatligi',
    'Davolash',
    'Pediatriya',
    'Xalqaro',
  ],
  kafedra: [
    'Kommunal va mehnat gigiyenasi',
    'Ovqatlanish, bolalar va o’smirlar gigienasi',
    'Preventiv tibbiyot asoslari, jamoat salomatligi, jismoniy tarbiya va sport',
    'Epidemiologiya va yuqumli kasalliklar, hamshiralik ishi',
    'Mikrobiologiya, virusologiya va immunologiya        ',
    'Xalq tabobati va farmakologiya',
    'Biotibbiyot muhandisligi, biofizika va axborot texnologiyalari',
    'Ichki kasallalliklar propedevtikasi (UASH)',
    'Terapiya yo‘nalishidagi fanlar (UASH)',
    'Travmatologiya va ortopediya',
    'Normal anatomiya, operativ jarrohlik va topografik anatomiya',
    'Gospital terapiya (laboratoriya)',
    'Umumiy jarrohlik',
    'Fakultet va gospital jarrohlik',
    'Akusherlik va ginekologiya',
    'Urologiya va onkologiya',
    'Nevrologiya va psixiatriya',
    'Pediatriya',
    'Pediatriya 2',
    'Stomatologiya va otoloringologiya',
    'Dermatovenerologiya va allergologiya',
    'Endokrinologiya, gemotologiya va ftiziatriya',
    "O'zbek va xorijiy tillar",
    'Lotin tili, pedagogika va psixologiya',
    'Tibbiy va biologik kimyo',
    'Ijtimoiy fanlar',
    'Gistologiya va biologiya',
    'Fiziologiya',
    'Patologik fiziologiya va patologik anatomiya',
  ],
};

const fstu_url = 'https://kpi.fstu.uz/api/';
// const fstu_url = 'http://localhost:3002/';
export const environment = {
  otm: 'fstu',
  firebase: {
    email: 'obidov.bekzod94@gmail.com',
    p: '7^^VnW5&9vY97!xa',
  },
  a: {
    email: 'O_A@',
    p: 'osha',
  },
  production: true,
  http_auth: '5KWBffF64Q7v6J9fLA4K',
  otm_name: "Ta'lim sifatini nazorat qilish bo'limi",
  firebaseConfig: {
    // pvorey
    apiKey: 'AIzaSyBmzKSP6a7bHTJWRZTqRgF3u8ucSJB2_fg',
    authDomain: 'pvorey.firebaseapp.com',
    databaseURL:
      'https://pvorey-default-rtdb.asia-southeast1.firebasedatabase.app',
    projectId: 'pvorey',
    storageBucket: 'pvorey.appspot.com',
    messagingSenderId: '975847085157',
    appId: '1:975847085157:web:5008868ba373c480ffa28c',
    measurementId: 'G-GRE7FMXH99',
  },
  http: {
    socket: {
      path: 'ws://kpi.fstu.uz/socket.io',
    },
    editArea: {
      path: fstu_url + 'system/area',
    },
    addArea: {
      path: fstu_url + 'system/area',
    },
    usersPaginated: {
      path: fstu_url + 'users/paginated',
    },
    updateUser: {
      path: fstu_url + 'users/',
    },
    deleteArea: {
      path: fstu_url + 'system/area',
    },
    removeDepartment: {
      path: fstu_url + 'system/department',
    },
    editDepartment: {
      path: fstu_url + 'system/department',
    },
    getDepartmentAArea: {
      path: fstu_url + 'system/getAll',
    },
    addDepartment: {
      path: fstu_url + 'system/department',
    },
    userRegister: {
      path: fstu_url + 'auth/registration',
    },
    recoverPass: {
      path: fstu_url + 'mailing/send-mail',
    },
    allRoles: {
      path: fstu_url + 'auth/login',
    },
    removeRole: {
      path: fstu_url + 'auth/login',
    },
    setRole: {
      path: fstu_url + 'auth/login',
    },
    removeTeacher: {
      path: fstu_url + 'auth/login',
    },
    allUsers: {
      path: fstu_url + 'users/all',
    },

    deleteUser: {
      path: fstu_url + 'auth/login',
    },
    login: {
      path: fstu_url + 'auth/login',
    },
    autologin: {
      path: fstu_url + 'auth/autologin',
    },
    updateIndex: {
      path: fstu_url + 'index/update',
    },
    rateIndex: {
      path: fstu_url + 'index/rate',
    },
    getIndexDataByTeacher: {
      path: fstu_url + 'index/get_index_data_by_teacher',
    },
    updateIndexOnlyShare: {
      path: fstu_url + 'index/get_index_data_by_teacher_only_share',
    },
    get: {
      path: 'https://kpi.fstu.uz/db/2025/get_data.php',
      file: 'pvorey.txt',
    },
    delete_only_inform_file: {
      path: 'https://kpi.fstu.uz/db/2025/delete_only_inform_file.php',
    },
    getFieldsInform: {
      path: 'https://kpi.fstu.uz/db/2025/get_fields_inform.php',
    },
    setInc: {
      path: 'https://kpi.fstu.uz/db/2025/set_data_inc.php',
      file: 'pvorey.txt',
    },
    del: {
      path: 'https://kpi.fstu.uz/db/2025/del_data.php',
      file: 'pvorey.txt',
    },

    setIncDelUpd: {
      path: 'https://kpi.fstu.uz/db/2025/set_inc_del_upd.php',
      file: 'pvorey.txt',
    },
    remDocDownGrade: {
      path: 'https://kpi.fstu.uz/db/2025/rem_doc_with_down_grade.php',
    },
    googleScholarCited: {
      path: 'https://kpi.fstu.uz/db/2025/google_scholar.php',
    },
    googleScholarCitedAll: {
      path: 'https://kpi.fstu.uz/db/2025/google_scholar_all.php',
    },
    setNewPvo: {
      path: 'https://kpi.fstu.uz/db/2025/set_new_pvo.php',
    },
    removePvo: {
      path: 'https://kpi.fstu.uz/db/2025/remove_pvo.php',
    },
    controlIndexStatus: {
      path: 'https://kpi.fstu.uz/db/2025/control_index_status.php',
    },
    createAnnounce: {
      path: 'https://kpi.fstu.uz/db/2025/create_announce.php',
    },
    getAnnounces: {
      path: 'https://kpi.fstu.uz/db/2025/get_announces.php',
    },
    removeAnnounce: {
      path: 'https://kpi.fstu.uz/db/2025/remove_announce.php',
    },
    editUserAccaunt: {
      path: 'https://kpi.fstu.uz/db/2025/edit_user_account.php',
    },
    createIndex: {
      path: 'https://kpi.fstu.uz/db/2025/create_index.php',
    },
  },
  tizim: [
    {
      fakultet: 'Mexanika - mashinasozlik',
      kafedralar: [
        'Mashinasozlik texnologiyasi',
        'Tadbiqiy mexanika',
        'Texnologik mashinalar va jihozlar',
        'Transport vositalari muhandisligi',
      ],
    },
    {
      fakultet: 'Energetika muhandisligi',
      kafedralar: [
        'Elektronika va asbobsozlik',
        'Energetika muhandisligi',
        'Elektr muhandisligi',
        'Fizika',
      ],
    },
    {
      fakultet: 'Arxitektura va qurilish',
      kafedralar: [
        'Arxitektura va kompyuter grafikasi',
        'Qurilish muhandisligi',
        'Geodeziya, kartografiya va kadastr',
        'Muhandislik kommunikatsiyalari qurilishi va montaji',
        'Qurilish materiallari va buyumlari',
      ],
    },
    {
      fakultet: 'Ishlab chiqarishda boshqaruv',
      kafedralar: [
        'Moliya va buxgalteriya hisobi',
        'Iqtisodiyot',
        'Menejment va marketing',
        'Oliy matematika',
      ],
    },
    {
      fakultet: 'Kimyo texnologiya',
      kafedralar: [
        'Kimyo muhandisligi',
        'Neft va neft-gazni qayta ishlash texnologiyasi',
        'Oziq-ovqat texnologiyasi va xavfsizligi',
        'Metrologiya standartlashtirish va maxsulot sifati menejmenti',
      ],
    },

    {
      fakultet: "Yengil sanoat va to'qimachilik",
      kafedralar: [
        'Ijtimoiy fanlar va sport',
        'O‘zbek tili va tillarni o‘rgatish',
        'Yengil sanoat texnologiya va jihozlari',
        'Yengil sanoat muhandisligi',
      ],
    },
    {
      fakultet: 'Axborot texnologiyalari va telekommunikatsiya',
      kafedralar: [
        'Axborot tizimlari va texnologiyalari',
        'Kompyuter muhandisligi va sun’iy intellekt',
        'Telekommunikatsiya muhandisligi',
        'Dasturiy injiniring va kiberxavfsizlik',
      ],
    },
  ],
  grastud: 556,
  fakultet: [
    'Mexanika - mashinasozlik',
    'Energetika muhandisligi',
    'Arxitektura va qurilish',
    'Ishlab chiqarishda boshqaruv',
    'Kimyo texnologiya',
    "Yengil sanoat va to'qimachilik",
    'Axborot texnologiyalari va telekommunikatsiya',
  ],
  kafedra: [
    'Mashinasozlik texnologiyasi',
    'Tadbiqiy mexanika',
    'Texnologik mashinalar va jihozlar',
    'Transport vositalari muhandisligi',
    'Elektronika va asbobsozlik',
    'Energetika muhandisligi',
    'Elektr muhandisligi',
    'Fizika',
    'Arxitektura va kompyuter grafikasi',
    'Qurilish muhandisligi',
    'Geodeziya, kartografiya va kadastr',
    'Muhandislik kommunikatsiyalari qurilishi va montaji',
    'Qurilish materiallari va buyumlari',
    'Moliya va buxgalteriya hisobi',
    'Iqtisodiyot',
    'Menejment va marketing',
    'Oliy matematika',
    'Kimyo muhandisligi',
    'Neft va neft-gazni qayta ishlash texnologiyasi',
    'Oziq-ovqat texnologiyasi va xavfsizligi',
    'Metrologiya standartlashtirish va maxsulot sifati menejmenti',
    'Ijtimoiy fanlar va sport',
    'O‘zbek tili va tillarni o‘rgatish',
    'Yengil sanoat texnologiya va jihozlari',
    'Yengil sanoat muhandisligi',
    'Axborot tizimlari va texnologiyalari',
    'Kompyuter muhandisligi va sun’iy intellekt',
    'Telekommunikatsiya muhandisligi',
    'Dasturiy injiniring va kiberxavfsizlik',
  ],
};
